/* Pregfancy — collection filters: AJAX via Section Rendering API, drawer, price slider */
(function(){
  'use strict';
  var root=document.querySelector('[data-pfc]');if(!root)return;
  var sid=root.getAttribute('data-section'),form=root.querySelector('[data-pfc-form]');
  var side=root.querySelector('[data-pfc-side]'),opener=root.querySelector('[data-pfc-open]');
  var timer=null,ctrl=null,lastFocus=null;

  /* sticky offset under the theme header */
  var header=document.querySelector('.header-main')||document.querySelector('header');
  var bar=root.querySelector('[data-pfc-bar]'),tk=false;
  var lastTop=-1;
  function setTop(){tk=false;var b=header?Math.max(0,header.getBoundingClientRect().bottom):0;b=Math.round(b);if(b!==lastTop){lastTop=b;root.style.setProperty('--pfc-top',b+'px');}if(bar)bar.classList.toggle('is-stuck',bar.getBoundingClientRect().top<=b+1);}
  window.addEventListener('scroll',function(){if(!tk){tk=true;requestAnimationFrame(setTop);}},{passive:true});setTop();

  /* drawer */
  function open(){lastFocus=document.activeElement;root.classList.add('is-open');document.documentElement.classList.add('pfc-drawer');opener&&opener.setAttribute('aria-expanded','true');document.documentElement.style.overflow='hidden';var f=side.querySelector('button,summary,input');f&&f.focus();}
  function close(){if(!root.classList.contains('is-open'))return;root.classList.remove('is-open');setTimeout(function(){if(!root.classList.contains('is-open'))document.documentElement.classList.remove('pfc-drawer');},500);opener&&opener.setAttribute('aria-expanded','false');document.documentElement.style.overflow='';lastFocus&&lastFocus.focus&&lastFocus.focus();}
  root.addEventListener('click',function(e){
    if(e.target.closest('[data-pfc-open]')){open();}
    else if(e.target.closest('[data-pfc-close]')){close();}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')close();});

  /* price slider */
  function bindPrice(scope){
    scope.querySelectorAll('[data-pfc-price]').forEach(function(p){
      var max=parseFloat(p.dataset.max)||100,lo=p.querySelector('[data-pfc-lo]'),hi=p.querySelector('[data-pfc-hi]'),ln=p.querySelector('[data-pfc-lo-n]'),hn=p.querySelector('[data-pfc-hi-n]');
      function paint(){p.style.setProperty('--lo',(lo.value/max*100)+'%');p.style.setProperty('--hi',(hi.value/max*100)+'%');}
      function fromRange(e){
        if(+lo.value>+hi.value){if(e.target===lo)lo.value=hi.value;else hi.value=lo.value;}
        ln.value=+lo.value>0?lo.value:'';hn.value=+hi.value<max?hi.value:'';paint();
      }
      lo.addEventListener('input',fromRange);hi.addEventListener('input',fromRange);
      lo.addEventListener('change',schedule);hi.addEventListener('change',schedule);
      [ln,hn].forEach(function(n){n.addEventListener('input',function(){lo.value=ln.value||0;hi.value=hn.value||max;paint();});});
      paint();
    });
  }

  /* fetch + swap */
  function params(){
    var fd=new FormData(form),q=new URLSearchParams();
    fd.forEach(function(v,k){if(v!=='')q.append(k,v);});
    return q.toString();
  }
  function focusKey(){var a=document.activeElement;if(!a||!root.contains(a))return null;if(a.name)return a.name+'|'+(a.value||'');if(a.hasAttribute('data-pfc-close'))return 'close';return null;}
  function restoreFocus(k){if(!k)return;var el;if(k==='close')return;var parts=k.split('|');root.querySelectorAll('[name]').forEach(function(x){if(x.name===parts[0]&&(x.type!=='checkbox'||x.value===parts[1]))el=el||x;});el&&el.focus({preventScroll:true});}
  function swap(html,append){
    var doc=new DOMParser().parseFromString(html,'text/html');
    var nroot=doc.querySelector('[data-pfc]');if(!nroot)return;
    var sel=['[data-pfc-active]','[data-pfc-facets]','.pfc-btn','.pfc-side__foot'];
    var openGroups={};root.querySelectorAll('.pfc-group').forEach(function(g,i){openGroups[i]=g.open;});
    if(append){
      var g=root.querySelector('[data-pfc-grid]');nroot.querySelectorAll('[data-pfc-grid] > *').forEach(function(c){g.appendChild(c);});
    }else{
      sel.push('[data-pfc-grid]');
    }
    sel.forEach(function(s){var a=root.querySelector(s),b=nroot.querySelector(s);if(a&&b)a.replaceWith(b);});
    var am=root.querySelector('[data-pfc-more]'),bm=nroot.querySelector('[data-pfc-more]');
    if(am&&bm)am.replaceWith(bm);else if(am&&!bm)am.remove();else if(!am&&bm)root.querySelector('.pfc-main').appendChild(bm);
    root.querySelectorAll('.pfc-group').forEach(function(g,i){if(i in openGroups)g.open=openGroups[i];});
    var tot=nroot.querySelector('[data-pfc-total]');root.querySelectorAll('[data-pfc-total]').forEach(function(t){if(tot)t.textContent=tot.textContent;});
    var live=root.querySelector('[data-pfc-live]');if(live&&tot)live.textContent=tot.textContent+' products';
    bindPrice(root);
    if(window.pfSoftReveal)window.pfSoftReveal(root);else root.querySelectorAll('[data-pf-reveal]').forEach(function(x){x.classList.add('is-in')});
  }
  function load(url,opts){
    opts=opts||{};
    if(ctrl)ctrl.abort();ctrl=new AbortController();
    var u=new URL(url,location.origin);u.searchParams.set('section_id',sid);
    root.classList.add('is-loading');
    var fk=focusKey();
    return fetch(u.toString(),{signal:ctrl.signal,credentials:'same-origin'}).then(function(r){return r.text();}).then(function(html){
      swap(html,opts.append);root.classList.remove('is-loading');
      if(!opts.append&&!opts.pop){var clean=new URL(url,location.origin);clean.searchParams.delete('section_id');history.pushState({pfc:1},'',clean.pathname+clean.search);}
      restoreFocus(fk);
    }).catch(function(e){if(e.name!=='AbortError'){root.classList.remove('is-loading');location.href=url;}});
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(function(){load(root.dataset.url+'?'+params());},420);}
  form.addEventListener('change',function(e){if(e.target.matches('[data-pfc-lo],[data-pfc-hi]'))return;schedule();});
  form.addEventListener('submit',function(e){e.preventDefault();load(root.dataset.url+'?'+params());});
  root.addEventListener('click',function(e){
    var a=e.target.closest('a[data-pfc-link]');if(a){e.preventDefault();load(a.href);return;}
    var n=e.target.closest('a[data-pfc-next]');if(n){e.preventDefault();n.setAttribute('aria-busy','true');n.textContent='Loading…';load(n.href,{append:true});}
  });
  window.addEventListener('popstate',function(){load(location.href,{pop:true});});
  bindPrice(root);
})();